// Core
import { takeEvery, all, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// Types
import { 
    ASYNC_NOMENCLATURE_DETAIL,
    ASYNC_NOMENCLATURE_LIST,
    ASYNC_NOMENCLATURE_CHANGE,
    ASYNC_NOMENCLATURE_CREATE,
    ASYNC_NOMENCLATURE_DELETE,
} from '../types'

// Workers
import { 
    fetchNomenclatureChange,
    fetchNomenclatureCreate,
    fetchNomenclatureDelete,
    fetchNomenclatureDetail,
    fetchNomenclatureList
 } from './worker';

function* watchFetchNomenclatureList (): SagaIterator {
    yield takeEvery(ASYNC_NOMENCLATURE_LIST, fetchNomenclatureList)
}

function* watchFetchNomenclatureDetail (): SagaIterator {
    yield takeEvery(ASYNC_NOMENCLATURE_DETAIL, fetchNomenclatureDetail)
}

function* watchFetchNomenclatureDelete (): SagaIterator {
    yield takeEvery(ASYNC_NOMENCLATURE_DELETE, fetchNomenclatureDelete)
}

function* watchFetchNomenclatureCreate (): SagaIterator {
    yield takeEvery(ASYNC_NOMENCLATURE_CREATE, fetchNomenclatureCreate)
}

function* watchFetchNomenclatureChange (): SagaIterator {
    yield takeEvery(ASYNC_NOMENCLATURE_CHANGE, fetchNomenclatureChange)
}


export function* watchNomenclature (): SagaIterator {
    yield all([
        call(watchFetchNomenclatureList),
        call(watchFetchNomenclatureDetail),
        call(watchFetchNomenclatureDelete),
        call(watchFetchNomenclatureCreate),
        call(watchFetchNomenclatureChange),
    
    ]);
}